export default function Testimonial() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-600 uppercase tracking-wider mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
              Community Voice
            </span>
            <blockquote className="font-heading text-xl md:text-3xl lg:text-4xl italic text-foreground-900 leading-relaxed mb-6">
              &ldquo;The Kakobuy Spreadsheet database completely transformed how I discover and compare products. Instead of browsing dozens of sites, I have everything organized in one place. It saves me hours every week and I have found products I would never have discovered otherwise.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div>
                <div className="text-sm font-semibold text-foreground-900">Marcus Chen</div>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="text-xs text-foreground-500">Verified Shopper</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-primary-500 text-sm"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1">
            <div className="w-full aspect-[3/4] max-w-sm mx-auto rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20stylish%20young%20man%20with%20warm%20smile%20in%20casual%20modern%20blazer%2C%20sitting%20relaxed%20in%20bright%20cafe%20interior%2C%20soft%20natural%20window%20lighting%2C%20editorial%20lifestyle%20portrait%20photography%2C%20warm%20inviting%20atmosphere%2C%20genuine%20confident%20expression%2C%20shallow%20depth%20of%20field&width=500&height=667&seq=testimonial-portrait-v3&orientation=portrait"
                alt="Satisfied Kakobuy Spreadsheet user Marcus Chen"
                title="Kakobuy Spreadsheet community member"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}